import {v4 as uuidV4} from 'uuid';
import SearchTracking, {SEARCH_TRACKING_ACTIONS} from 'utils/search-tracking';
import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import {getFacilitiesByPackage} from 'api/event-packages';
import {notify} from '../notification/notification-actions';
import trackErrorMessageDisplayed from 'segment/events/error-message-displayed';
import {getFacilitiesByPackageV2} from 'api/search-v2/event-packages/get-facilities-by-package';
import ExperimentUtils, {IMMEDIATE_FEATURES} from 'utils/experiment';

export const SPOTS_GET_EVENT_PACKAGE = 'SPOTS_GET_EVENT_PACKAGE';

export const loadSpotsEventPackage = ({eventPackageId}) => {
    return (dispatch, getState) => {
        const segmentId = SegmentUtils.getAnonymousId();
        const prevState = getState();
        const searchRequestState = prevState.searchRequest;
        const {filterSpot} = searchRequestState;

        SearchTracking.updateAction(SEARCH_TRACKING_ACTIONS.SEARCH);
        const {
            sessionUUID,
            searchUUID,
            actionUUID,
        } = SearchTracking.getValues();

        const useEventPackageV2Search = ExperimentUtils.isFeatureEnabled(
            IMMEDIATE_FEATURES.USE_EVENT_PACKAGE_V2_SEARCH
        );

        const apiToDispatch = useEventPackageV2Search
            ? getFacilitiesByPackageV2
            : getFacilitiesByPackage;

        /* eslint-disable camelcase */
        return dispatch({
            type: SPOTS_GET_EVENT_PACKAGE,
            payload: apiToDispatch(
                eventPackageId,
                {
                    session_id: sessionUUID,
                    search_id: searchUUID,
                    action_id: actionUUID,
                    segment_id: segmentId,
                    include: 'amenities_full',
                },
                {filterSpot}
            ).then(response => {
                return {
                    results: response,
                };
            }),
        }).catch(error => {
            trackErrorMessageDisplayed({
                message: 'Error fetching spots',
                screen: 'search',
                action: 'fetching spots',
            });

            dispatch(
                notify({
                    id: uuidV4(),
                    type: 'error',
                    message: 'Error fetching spots',
                })
            );

            return ErrorUtils.formatError(error);
        });
        /* eslint-enable camelcase */
    };
};

export const loadEventPackageSpot = ({eventPackageId}) => {
    return dispatch => {
        return dispatch(
            loadSpotsEventPackage({
                eventPackageId,
            })
        );
    };
};
